var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{attrs:{"id":"faq"}},_vm._l((_vm.$config.common.faq.items),function(item,index){return _c('FaqItem',{key:index,staticClass:"faq-item",attrs:{"question":item.question,"answer":item.answer,"opened":_vm.openedIndex === index},nativeOn:{"click":function($event){return _vm.toggle(index)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }